/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProvinceDto } from '../../models/province-dto';

export interface ProvinceGet$Params {
  ProvinceId?: number;
}

export function provinceGet(http: HttpClient, rootUrl: string, params?: ProvinceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProvinceDto>>> {
  const rb = new RequestBuilder(rootUrl, provinceGet.PATH, 'get');
  if (params) {
    rb.query('ProvinceId', params.ProvinceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProvinceDto>>;
    })
  );
}

provinceGet.PATH = '/v1/Province/Get';
